import { render, staticRenderFns } from "./Berthing.vue?vue&type=template&id=2e52df7b&scoped=true&"
import script from "./Berthing.vue?vue&type=script&lang=js&"
export * from "./Berthing.vue?vue&type=script&lang=js&"
import style0 from "./Berthing.vue?vue&type=style&index=0&id=2e52df7b&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e52df7b",
  null
  
)

export default component.exports